// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2UR4g","colCheckbox":"styles_colCheckbox__3qDqH"};